import { Injectable } from '@angular/core';

import { StakeConfig } from '@frontend/sports/common/client-config-data-access';
import Decimal from 'decimal.js';

import { IBetslip } from '../../../../bet-generation/models';
import { isFreebetToken } from '../../../../reward-tokens/services/reward-tokens.utils';
import BetslipStakeConfigurationService from '../../../../stake/services/betslip-stake-configuration.service';
import { getSlipTotalStakeAndBetCount } from '../../../../summary/services/betslip-summary-helpers';
import { OverMaximumStakePreCheckError } from '../../../errors/pre-check/over-maximum-stake-pre-check-error';
import { IContextBetslipValidator } from './validators';

@Injectable()
export class OverMaximumStakeBetslipValidator implements IContextBetslipValidator<OverMaximumStakePreCheckError> {
    constructor(
        private stakeConfigService: BetslipStakeConfigurationService,
        private stakeConfig: StakeConfig,
    ) {}

    validate(betslip: IBetslip): OverMaximumStakePreCheckError[] {
        const isFreebet = betslip.slips.some((s) => isFreebetToken(s.rewardToken));

        if (!this.stakeConfig.isMaxStakePerBetslipStrategy || !this.stakeConfigService.maxStake || isFreebet) {
            // max stake validated per bet OR
            // no max stake configured OR
            // is free bet
            return [];
        }

        const maximumStake = new Decimal(this.stakeConfigService.maxStake);

        const { totalStake, betCount } = betslip.slips.reduce(
            (acc, curr) => {
                const slipResult = getSlipTotalStakeAndBetCount(curr);

                return {
                    totalStake: acc.totalStake + (slipResult.totalStake?.toNumber() || 0),
                    betCount: acc.betCount + slipResult.betCount,
                };
            },
            { totalStake: 0, betCount: 0 },
        );

        return new Decimal(totalStake).greaterThan(maximumStake)
            ? [new OverMaximumStakePreCheckError(maximumStake.toNumber(), totalStake, betCount)]
            : [];
    }
}
